/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useSelector } from "react-redux";

import { Card, CardBody, CardHeader } from "../../_metronic/_partials/controls";
import DashboardTable from "./DashboardTable";

export function DashboardPage() {
  const [wp, setWp] = useState([]);
  const [content, setContent] = useState([]);
  const [data, setData] = useState([]);
  const { npwp } = useSelector((state) => state.auth);

  const [tab, setTab] = useState("aktif");

  // const npwp = "001243443627000";

  // useEffect(() => {
  //   getProfilWp(npwp)
  //     .then(({ data }) => {
  //       if (data.kdStatus === "1") {
  //         setContent(data.resDtWpSimpleType[0]);
  //       }
  //     })
  //     .catch((err) => {
  //       swal("Gagal", err.message, "error");
  //     });
  // }, []);

  return (
    <>
      <>
        <Card>
          <CardHeader
            title="Dashboard Referensi Fasilitas"
            style={{ backgroundColor: "#FFC91B" }}
          ></CardHeader>
          <CardBody>
            <div className="mt-5">
          <DashboardTable npwp={npwp}/>
          </div>

            {/* <ul className="nav nav-tabs nav-tabs-line " role="tablist">
              <li className="nav-item" onClick={() => setTab("aktif")}>
                <a
                  className={`nav-link ${tab === "aktif" && "active"}`}
                  data-toggle="tab"
                  role="tab"
                  aria-selected={(tab === "aktif").toString()}
                >
                  Permohonan Aktif
                </a>
              </li>
              <>
                {" "}
                <li className="nav-item" onClick={() => setTab("nonaktif")}>
                  <a
                    className={`nav-link ${tab === "nonaktif" && "active"}`}
                    data-toggle="tab"
                    role="button"
                    aria-selected={(tab === "nonaktif").toString()}
                  >
                    Permohonan Tidak Aktif
                  </a>
                </li>
              </>
            </ul>
            <div className="mt-5">
            {tab === "aktif" && <DashboardTable npwp={npwp}/>}
            {tab === "nonaktif" && <DashboardTable tab={"nonaktif"} npwp={npwp}/>}
          </div> */}
          </CardBody>
        </Card>
      </>
    </>
  );
}
